
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/components/ui/use-toast";

export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    // Extract the code from URL
    const handleAuthRedirect = async () => {
      try {
        // Process the OAuth login callback
        const { data, error } = await supabase.auth.getSession();
        
        if (error) {
          console.error("Auth callback error:", error);
          toast({
            title: "Authentication Error",
            description: error.message || "Failed to complete authentication",
            variant: "destructive",
          });
          navigate("/login");
          return;
        }
        
        if (data.session) {
          // Mark login as successful
          localStorage.setItem("loginSuccessFlag", "true");
          
          // Redirect to dashboard
          toast({
            title: "Authentication Successful",
            description: "You have been signed in",
          });
          navigate("/dashboard");
        } else {
          // No session, something went wrong
          navigate("/login");
        }
      } catch (err) {
        console.error("Failed to process auth callback:", err);
        toast({
          title: "Authentication Error",
          description: "An unexpected error occurred during authentication",
          variant: "destructive",
        });
        navigate("/login");
      }
    };

    handleAuthRedirect();
  }, [navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-muted/40">
      <div className="flex flex-col items-center">
        <div className="animate-spin h-12 w-12 border-4 border-primary border-t-transparent rounded-full mb-4"></div>
        <h2 className="text-2xl font-semibold mb-2">Completing Authentication</h2>
        <p className="text-muted-foreground">Please wait while we log you in...</p>
      </div>
    </div>
  );
}
